import script from "./ProfileTab.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileTab.vue?vue&type=script&setup=true&lang=js"

import "./ProfileTab.vue?vue&type=style&index=0&id=5897bc4a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/channel-xyz/channel-xyz/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5897bc4a"]])

export default __exports__